import { render, staticRenderFns } from "./AbsenceForm.vue?vue&type=template&id=6225806c&scoped=true"
import script from "./AbsenceForm.vue?vue&type=script&lang=js"
export * from "./AbsenceForm.vue?vue&type=script&lang=js"
import style0 from "./AbsenceForm.vue?vue&type=style&index=0&id=6225806c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6225806c",
  null
  
)

export default component.exports